/* Determine the new element index to display */
function currentEleCycle(displayContainerId, indexChange, navContainerId) {

	navContainerId = navContainerId || null; /* Setting default value */

	/* The currently displayed index */
	var displayedIndex = null;

	/* Determine index of currently displayed element */
	var cycleElements = document.getElementById(displayContainerId).children;
	for(i=0; i < cycleElements.length; i++) {
        if (cycleElements[i].classList.contains("cycleActive")) {
			displayedIndex = i;
		}
	}

	/* Request new element */
    showEleCycle(displayContainerId, displayedIndex, displayedIndex += indexChange, navContainerId);
}


/* When the navigation is clicked */
function navEleCycle(displayContainerId, newIndex, navContainerId) {
	/* The currently displayed index */
	var displayedIndex = null;

	/* Determine index of currently displayed element */
	var cycleElements = document.getElementById(displayContainerId).children;
	for(i=0; i < cycleElements.length; i++) {
        if (cycleElements[i].classList.contains("cycleActive")) {
			displayedIndex = i;
		}
	}

	/* Request new element */
    showEleCycle(displayContainerId, displayedIndex, newIndex, navContainerId);

}

/* Cycles through elements */
function showEleCycle(displayContainerId, currentIndex, newIndex, navContainerId) {

	navContainerId = navContainerId || null; /* Setting default value */

	/* Get the number of elements */
	var cycleElements = document.getElementById(displayContainerId).children;
	var navElements = null;
	var direction = null;

	/* determine direction */
	if(newIndex > currentIndex){
		direction = 'left';
	} else {
		direction = 'right';
	}

	/* Get the navigation elements */
	if(navContainerId != null) {
		navElements = document.getElementById(navContainerId).children;
		navWrapper = document.getElementById(navContainerId).parentNode;
	}

	/* Determine if the requested element is in range */
    if (newIndex > cycleElements.length - 1) {
		newIndex = 0
	}else if (newIndex < 0) {
		newIndex = cycleElements.length - 1
	}

	/* Set class for inactive elements */
	for(var i=0; i < cycleElements.length; i++) {
		/* Sets the displayed item classes */

		/* Add classes to departing element */
		if(cycleElements[i].classList.contains("cycleActive")) {

			/* Determine if going left or right */
			if(direction === 'left'){
				cycleElements[i].classList.add("cycleOutLeft");
			} else {
				cycleElements[i].classList.add("cycleOutRight");
			}
		}

		/* Remove old classes */
		cycleElements[i].classList.remove("cycleActive");
		cycleElements[i].classList.remove("cycleInLeft");
		cycleElements[i].classList.remove("cycleInRight");
		cycleElements[i].classList.add("cycleInactive");

		/* Sets the navigation item classes */
		if(navContainerId != null) {
			navElements[i].classList.remove("cycleNavActive");
			navElements[i].classList.add("cycleNavInactive");
		}
	}

	/* Set classes for active element */
	cycleElements[newIndex].classList.remove("cycleOutLeft");
	cycleElements[newIndex].classList.remove("cycleOutRight");
	cycleElements[newIndex].classList.remove("cycleInactive");
	cycleElements[newIndex].classList.add("cycleActive");

	/* Determine if going left or right */
	if(direction === 'left'){
		cycleElements[newIndex].classList.add("cycleInLeft");
	} else {
		cycleElements[newIndex].classList.add("cycleInRight");
	}

	/* Sets the navigation item classes */
	if(navContainerId != null) {
		navElements[newIndex].classList.remove("cycleNavInactive");
		navElements[newIndex].classList.add("cycleNavActive");
	}
}

    /* lightbox */
    $(document).ready(function() {
		$('.lightbox-video').magnificPopup({type:'iframe', zoom: {enabled: true, duration: 300, easing: 'ease-in-out'}, removalDelay: 300, mainClass: 'mfp-fade'});
		$('.lightbox-image').magnificPopup({type:'image', zoom: {enabled: true, duration: 300, easing: 'ease-in-out'}, removalDelay: 300, mainClass: 'mfp-fade'});
	});

	/* Touch support */
	(function(l){
		var M=Math,ce,cx,cy,dx,dy,b,f,i,m,s,t=function(e,i){m=i; i=e.touches; return{x:i[0].pageX,y:i[0].pageY,z:i.length}};
		for(i in s={touchcancel:function(e){m=0},touchstart:function(e){b=t(e,0)},touchmove:function(e){f=t(e,1)},touchend:function(e){if(b.z>1)return; ce=l.createEvent('CustomEvent');
		ce.initCustomEvent(m?(M.max(dx=M.abs(cx=f.x-b.x),dy=M.abs(cy=f.y-b.y))>25?dx>dy?cx<0?'l':'r':cy<0?'u':'d':'fc'):'fc',true,true,b); e.target.dispatchEvent(ce);}
		}) l.addEventListener(i,s[i],false)})(document);

	/* Adding touch event listeners */
	var slideShow = document.getElementById("featureSlides");
	var imgCycle = document.getElementById("cycleImages");
	var autoCycle;

	/* Touch for ImgCycle */
	if(cycleImages) {
		cycleImages.addEventListener('r', imgCycleRight, false);
		cycleImages.addEventListener('l', imgCycleLeft, false);
	}

	/* Touch for slideshow */
	if(slideShow) {
		slideShow.addEventListener('r', slideShowRight, false);
		slideShow.addEventListener('l', slideShowLeft, false);
	}

	// auto clicks on navigation to cycle through
	autoNavCycle = (navWrapperId) => {

		let navWrapperEle = document.getElementById(navWrapperId);
		let navElements = navWrapperEle.children;
		let nextIndex = null;

		// find currently selected element
		for (let i = 0; i < navElements.length; i++){

			if(navElements[i].classList.contains('selected')){
				nextIndex = i + 1;
				if(nextIndex >= navElements.length){
					nextIndex = 0;
				}
			}
		}
		navElements[nextIndex].click();
	}

	// Handle navigation click for visual cycle
	clickNavCycleHandler = (e) => {
		let navEle = e.target;
		let navEleParent = null;
		let allNav = null;
		let displayEle = null;
		let displayEleChildren = null;
		let isVideo = false;
		let oldSelected = null;
		let newSelected = null;

		// Get the nav element wrapper
		if(navEle.dataset.navid){
			navEleParent = document.getElementById(navEle.dataset.navid);
			allNav = navEleParent.children;
		}

		// Get the main display element
		if(navEle.dataset.displayid){
			displayEle = document.getElementById(navEle.dataset.displayid);
			displayEleChildren = displayEle.children;
			if(displayEle.dataset.isvideo){
				isVideo = true;
			}
		}

		//Check that required elements are set
		if(navEle && navEleParent && allNav && displayEle && displayEleChildren){

			//Remove previously selected class from navigation
			for (var i = 0; i < allNav.length; i++) {
				if(allNav[i].classList.contains('selected')) {
					oldSelected = document.getElementById(allNav[i].dataset.visualid);
				}
				allNav[i].classList.remove('selected');
			}

			//Adding selected class to clicked nav element
			navEle.classList.add('selected');

			// Determine the id of the new display element
			for( var i =0; i < displayEleChildren.length; i++) {

				if(displayEleChildren[i].id == navEle.dataset.visualid){
					newSelected = displayEleChildren[i];
				}
			}

			// Change displayed visual
			if(oldSelected && newSelected){
				if(isVideo){
					switchDisplayedSyncedVideo(oldSelected, newSelected);
				}else{
					oldSelected.style.opacity=0;
					newSelected.style.opacity=1;
				}
			}
		}
	}

	// Switches between videos. Plays the new video and pauses the old one
	// oldEle = previously displayed video element
	// newEle = new video element to be displayed
	function switchDisplayedSyncedVideo(oldEle, newEle) {
		let playTime = oldEle.currentTime;
		setTimeout(function(){oldEle.pause();},1500);
		newEle.currentTime = playTime;
		newEle.play();
		oldEle.style.opacity=0;
		newEle.style.opacity=1;
	}

	// Syncs the currenTime of hidden videos with the one displayed
	function syncVideos(videoId) {
		let vidWrapper = document.getElementById(videoId);
		let allVids = vidWrapper.querySelectorAll('video');
		let shownVid = null;
		let playTime = null;

		// Check there is more than one video
		if(allVids.length > 1) {

			// Find the currently displayed video
			for(let i =0; i < allVids.length; i++){
				if(allVids[i].style.opacity == 1){
					shownVid = allVids[i];
					playTime = shownVid.currentTime;
				}
			}

			// Setting currentTime on all videos to the displayed video to stay in sync
			for(let i =0; i < allVids.length; i++){
				if(allVids[i].style.opacity == 0) {
					allVids[i].currentTime = playTime;
				}
			}
		}

		/*
		//Reruns this funciton every 5 seconds
		setTimeout(() => {
			syncVideos(videoId);
		}, 5000)
		*/
	}

	// Event Listeners for Flex Volume section
	if(document.getElementById('flexCaptureVolumeNav')) {

		// Intervals to track the cycling images/videos and start/stop them
		let captureVolumeInterval;

		// Adding Thumbnail navigation event listeners for the visual cycle
		const thumbnailsNav = document.querySelectorAll("#flexCaptureVolumeNav div");
		for (let i = 0; i < thumbnailsNav.length; i++) {
			// click event
			thumbnailsNav[i].addEventListener('click',clickNavCycleHandler);

			// mouseover event - stop the auto cycle
			thumbnailsNav[i].addEventListener('mouseover', () => {
				clearInterval(captureVolumeInterval);
			});

			// mouseout event - restarts the auto cycle
			thumbnailsNav[i].addEventListener('mouseout', () => {
				clearInterval(captureVolumeInterval);
				captureVolumeInterval = setInterval(() => {
					autoNavCycle('flexCaptureVolumeNav');
				}, 3000);
			});
		}

		// initial interval for Flex capture volume images cycle
		captureVolumeInterval = setInterval(() => {
			autoNavCycle('flexCaptureVolumeNav');
		}, 3000);


	}

	// On Camera Image Processing Event Listeners
	if(document.getElementById('onCameraImageProcessing')) {
		// Adding button navigation event listeners for the visual cycle
		const buttonImgCycleNav = document.querySelectorAll("#flexImageProcessingNav button");
		for (let i = 0; i < buttonImgCycleNav.length; i++) {
			buttonImgCycleNav[i].addEventListener('click',clickNavCycleHandler);
		}
	}

	// Basketball video Event Listeners
	if(document.getElementById('bbMoCap')) {
		let bbMoCapInterval;

		// Adding button navigation event listeners for the basketball video cycle
		const buttonBBVideoCycleNav = document.querySelectorAll("#bbMoCapNav button");
		for (let i = 0; i < buttonBBVideoCycleNav.length; i++) {
			// click event
			buttonBBVideoCycleNav[i].addEventListener('click',clickNavCycleHandler);

			// mouseover event - stop the auto cycle
			buttonBBVideoCycleNav[i].addEventListener('mouseover', () => {
				clearInterval(bbMoCapInterval);
			});

			// mouseout event - restarts the auto cycle
			buttonBBVideoCycleNav[i].addEventListener('mouseout', () => {
				clearInterval(bbMoCapInterval);
				bbMoCapInterval = setInterval(() => {
					autoNavCycle('bbMoCapNav');
				}, 3000);
			});
		}

		// Syncs the basketball videos
		//syncVideos('bbMoCap');

		// initial interval for basketball videos cycle
		bbMoCapInterval = setInterval(() => {
			autoNavCycle('bbMoCapNav');
		}, 3000);
	}



	/* Touch functions */
	function slideShowRight() {
		currentEleCycle('featureSlides', -1,'featureSlideMarkers');
	}
	function slideShowLeft() {
		currentEleCycle('featureSlides', 1,'featureSlideMarkers');
	}
	function imgCycleRight() {
		currentEleCycle('cycleImages', -1);
	}
	function imgCycleLeft() {
		currentEleCycle('cycleImages', 1);
	}
